var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner__holder",class:{ 'spinner__holder--show': _vm.show }},[_c('svg',{staticClass:"spinner__item",attrs:{"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"spinner__item-path",attrs:{"fill":"none","stroke-width":"4","stroke-linecap":"round","cx":"23","cy":"23","r":"20"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ddf6aca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/spinner/Spinner.vue
// module id = zW8E
// module chunks = 0 1 3 4 5